import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { FormTextField, FormCheckbox, FormConditionalTextField } from '@ts-core/core/components/FormV2';

import { CoreExerciseFormInput } from '../../types/form';

import ExerciseMediaField from '../ExerciseMediaField';

const ExerciseCoreInfoForm = () => {
  const intl = useIntl();
  const { control } = useFormContext<CoreExerciseFormInput>();

  return (
    <Box>
      <FormTextField label="Identificador" rules={{ required: 'El identificador es requerido.' }} control={control} name="code" />
      <Stack mt={2} direction="row" spacing={5} alignItems="flex-start" width="100%">
        <FormCheckbox
          label="Disponible para practicar"
          control={control}
          name="forPractice"
          sx={{ mb: 2 }}
          tooltip={intl.formatMessage({ id: 'field.allowToPractice.explanation' })}
        />
        <FormConditionalTextField
          label="Tiempo límite (minutos)"
          checkboxLabel="Ejercicio con tiempo límite"
          control={control}
          name="timeLimit"
          type="number"
        />
      </Stack>
      <FormTextField label="Texto" fullWidth multiline maxRows={6} control={control} name="text" sx={{ mb: 2 }} />
      <ExerciseMediaField control={control} name="media" />
    </Box>
  );
};

export default ExerciseCoreInfoForm;
